import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Row, Col, Alert, Badge } from "react-bootstrap";
import { api } from "../../services/api";
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';



function ModalNovoChamado({ loja, show, onHide, onSuccess }) {
    const [setores, setSetores] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const chapa = localStorage.getItem("chapa");
    const [form, setForm] = useState({
        loja: "",
        setor: "",
        categoria: "",
        assunto: "",
        descricao: "",
        local: ""
    });

    const [arquivos, setArquivos] = useState([]);
    const [erro, setErro] = useState("");

    const removerAnexo = (indexParaRemover) => {
        setArquivos(prev => prev.filter((_, index) => index !== indexParaRemover));
    };

    const limparFormulario = () => {
        setForm({
            loja: "",
            setor: "",
            categoria: "",
            assunto: "",
            descricao: "",
            local: ""
        });
        setArquivos([]);
        setCategorias([]);
        setErro("");
    };

    useEffect(() => {
        if (show) {
            limparFormulario();
            carregarSetores();
            setForm(prev => ({ ...prev, loja: loja }));
        }
    }, [show, loja]);

    const carregarSetores = async () => {
        try {
            const res = await api.get("/chamados/setores");
            setSetores(res.data);
        } catch (e) {
            setErro("Erro ao carregar setores");
        }
    };

    const carregarCategorias = async (idSetor) => {
        try {
            const res = await api.get(`/chamados/categorias?setor=${idSetor}`);
            setCategorias(res.data);
        } catch (e) {
            setErro("Erro ao carregar categorias");
        }
    };

    const handleSetor = (e) => {
        const value = e.target.value;
        setForm({ ...form, setor: value, categoria: "" });
        carregarCategorias(value);
    };

    {/*const handleFiles = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];

        let arquivosValidos = [];
        let erroTipo = false;

        selectedFiles.forEach(file => {
            if (allowedTypes.includes(file.type)) {
                arquivosValidos.push(file);
            } else {
                erroTipo = true;
            }
        });

        if (erroTipo) {
            toast.error("Apenas imagens (JPG/PNG) ou PDF são permitidos.");
        }

        setArquivos(prev => {
            const total = [...prev, ...arquivosValidos];
            if (total.length > 3) {
                toast.warning("Limite máximo de 3 arquivos.");
                return total.slice(0, 3);
            }
            return total;
        });

        // Limpa o input para permitir selecionar o mesmo arquivo se ele for deletado da lista
        e.target.value = null;
    };*/}

    const handleFiles = (e) => {
        const selectedFiles = Array.from(e.target.files);
        // 🔥 Adicionado 'text/plain' para suportar TXT
        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg', 'text/plain'];

        let arquivosValidos = [];
        let erroTipo = false;

        selectedFiles.forEach(file => {
            if (allowedTypes.includes(file.type)) {
                arquivosValidos.push(file);
            } else {
                erroTipo = true;
            }
        });

        if (erroTipo) {
            // 🔥 Mensagem atualizada
            toast.error("Apenas imagens (JPG/PNG), PDF ou TXT são permitidos.");
        }

        setArquivos(prev => {
            const total = [...prev, ...arquivosValidos];
            if (total.length > 3) {
                toast.warning("Limite máximo de 3 arquivos.");
                return total.slice(0, 3);
            }
            return total;
        });

        e.target.value = null;
    };

    const toBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result.split(",")[1]);
            reader.onerror = reject;
        });
    };

    const salvar = async () => {
        // 1. Validação de Campos Obrigatórios
        if (!form.loja || form.loja.trim() === "") {
            setErro("O campo LOJA é obrigatório.");
            return;
        }

        if (!chapa || chapa.trim() === "") {
            setErro("Erro de autenticação: CHAPA não encontrada. Faça login novamente.");
            toast.error("Usuário não identificado.");
            return;
        }

        if (!form.setor || !form.categoria || !form.assunto.trim() || !form.descricao.trim()) {
            setErro("Por favor, preencha todos os campos obrigatórios (Setor, Categoria, Assunto e Descrição).");
            return;
        }

        // Limpa erro anterior se passar na validação
        setErro("");


        try {
            // Função auxiliar para converter arquivo em Base64
            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result.split(',')[1]); // Pega só o base64
                reader.onerror = error => reject(error);
            });

            const anexosPromessas = arquivos.map(async (file) => ({
                nome: file.name,
                base64: await toBase64(file)
            }));

            const anexosBase64 = await Promise.all(anexosPromessas);

            // Monta o objeto JSON puro
            const payload = {
                loja: parseInt(form.loja),
                id_setor: parseInt(form.setor),
                id_categoria: parseInt(form.categoria),
                assunto: form.assunto,
                descricao: form.descricao,
                local: form.local,
                usuario: chapa,
                anexos: anexosBase64 // O array de anexos
            };

            // Envia como JSON (padrão do axios quando passamos um objeto)
            const res = await api.post('/chamado', payload);

            if (res.status === 201 || res.status === 200) {
                Swal.fire({
                    title: "Sucesso!",
                    text: "Chamado aberto com sucesso!",
                    icon: "success"
                }).then((result) => {
                    if (result.isConfirmed) onSuccess();
                });
            }
        } catch (err) {
            console.error(err);
            Swal.fire({ title: "Erro!", text: "Erro ao gravar chamado.", icon: "error" });
        }
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Novo Chamado</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {erro && <Alert variant="danger">{erro}</Alert>}

                <Form>
                    <Row>
                        <Col md={2}>
                            <Form.Group>
                                <Form.Label>Loja</Form.Label>
                                <Form.Control
                                    value={loja}
                                    disabled={true}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={5}>
                            <Form.Group>
                                <Form.Label>Setor</Form.Label>
                                <Form.Select value={form.setor} onChange={handleSetor}>
                                    <option value="">Selecione</option>
                                    {setores.map(s => (
                                        <option key={s.id_setor} value={s.id_setor}>
                                            {s.nome_setor}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>

                        <Col md={5}>
                            <Form.Group>
                                <Form.Label>Categoria</Form.Label>
                                <Form.Select value={form.categoria}
                                    onChange={(e) => setForm({ ...form, categoria: e.target.value })}
                                >
                                    <option value="">Selecione</option>
                                    {categorias.map(c => (
                                        <option key={c.id_categoria} value={c.id_categoria}>
                                            {c.descricao}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Form.Group className="mt-3">
                        <Form.Label>Assunto</Form.Label>
                        <Form.Control
                            value={form.assunto}
                            onChange={(e) => setForm({ ...form, assunto: e.target.value })}
                        />
                    </Form.Group>

                    <Form.Group className="mt-3">
                        <Form.Label>Descrição</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={4}
                            value={form.descricao}
                            onChange={(e) => setForm({ ...form, descricao: e.target.value })}
                        />
                    </Form.Group>

                    <Form.Group className="mt-3">
                        <Form.Label>Local</Form.Label>
                        <Form.Control
                            value={form.local}
                            onChange={(e) => setForm({ ...form, local: e.target.value })}
                        />
                    </Form.Group>
                    {arquivos.length > 0 && (
                        <div className="d-flex flex-wrap gap-2 mt-2 p-2 bg-light rounded border">
                            {arquivos.map((file, index) => (
                                <Badge
                                    key={index}
                                    bg="primary"
                                    className="d-flex align-items-center p-2 rounded-pill shadow-sm"
                                    style={{ fontSize: '0.8rem' }}
                                >
                                    <i className="bi bi-paperclip me-1"></i>
                                    <span className="text-truncate" style={{ maxWidth: '120px' }}>
                                        {file.name}
                                    </span>
                                    <i
                                        className="bi bi-x-circle-fill ms-2"
                                        style={{ cursor: 'pointer', color: 'rgba(255,255,255,0.7)' }}
                                        onClick={() => removerAnexo(index)}
                                    ></i>
                                </Badge>
                            ))}
                        </div>
                    )}

                    <Form.Group className="mt-3">
                        <Form.Label>Anexos (PDF - Imagem - TXT - máx 3)</Form.Label>
                        <Form.Control
                            type="file"
                            multiple
                            accept="image/*,.pdf,.txt" // Filtra na janela de seleção do Windows
                            onChange={handleFiles}
                        />
                    </Form.Group>


                </Form>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Cancelar</Button>
                <Button variant="primary" onClick={salvar}>Salvar</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ModalNovoChamado;